module.exports = __webpack_public_path__ + "statics/img/indexfont.61e5bce1.png";